import { initialState } from "./state"

export default {
  setComboUuidEditing: (state, payload) => (state.comboUuidEditing = payload),
  setComboAlreadyFetchEditing: (state, payload) =>
    (state.comboAlreadyFetchEditing = payload),
  setComboName: (state, payload) => (state.comboName = payload),
  setComboCommercialName: (state, payload) =>
    (state.comboCommercialName = payload),
  setComboCategoriesOptions: (state, payload) =>
    (state.comboCategoriesOptions = payload),
  setComboCategorySelected: (state, payload) =>
    (state.comboCategorySelected = payload),
  setComboMovementsOptions: (state, payload) =>
    (state.comboMovementsOptions = payload),
  setComboMovementSelected: (state, payload) =>
    (state.comboMovementSelected = payload),
  setComboScore: (state, payload) => (state.comboScore = payload),
  setComboPhysicalPerson: (state, payload) =>
    (state.comboPhysicalPerson = payload),
  setComboLegalPerson: (state, payload) => (state.comboLegalPerson = payload),
  setComboActive: (state, payload) => (state.comboActive = payload),
  setComboRecommended: (state, payload) => (state.comboRecommended = payload),
  setComboShouldBeDisplayed: (state, payload) => (state.comboShouldBeDisplayed = payload),
  setComboIcon: (state, payload) => (state.comboIcon = payload),
  setComboIconPreview: (state, payload) => (state.comboIconPreview = payload),
  setComboCreatedThrough: (state, payload) => (state.comboCreatedThrough = payload),

  setComboPlanOptions: (state, payload) => (state.comboPlanOptions = payload),
  setComboPlansSelecteds: (state, payload) =>
    (state.comboPlansSelecteds = payload),
  addNewComboPlanSelected(state, newPlan) {
    state.comboPlansSelecteds.push(newPlan)
  },
  changeComboPlanSpecificSelected(state, { index, prop, value }) {
    state.comboPlansSelecteds[index][prop] = value
  },
  deleteComboPlanSelected(state, indexToRemove) {
    state.comboPlansSelecteds.splice(indexToRemove, 1)
  },
  togglePlansOptionsDisabled(state, valueOption) {
    const INDEX_OPTION_TO_MODIFY = state.comboPlanOptions.findIndex(
      option => option.value === valueOption
    )
    state.comboPlanOptions[INDEX_OPTION_TO_MODIFY].disabled =
      !state.comboPlanOptions[INDEX_OPTION_TO_MODIFY].disabled
  },

  setComboCampaignOptions: (state, payload) =>
    (state.comboCampaignOptions = payload),
  setComboCampaignSelecteds: (state, payload) =>
    (state.comboCampaignSelecteds = payload),

  setComboCoverageOptions: (state, payload) =>
    (state.comboCoverageOptions = payload),
  updateComboCoverageOption(state, payload) {
    state.comboCoverageOptions[payload.index][payload.prop] = payload.newValue
  },

  setComboAccessOptions: (state, payload) =>
    (state.comboAccessOptions = payload),
  updateComboAccessOption(state, payload) {
    state.comboAccessOptions[payload.index][payload.prop] = payload.newValue
  },

  setComboDiscountOptions: (state, payload) =>
    (state.comboDiscountOptions = payload),
  updateComboDiscountOption(state, payload) {
    state.comboDiscountOptions[payload.index][payload.prop] = payload.newValue
  },
  setComboDiscountTypes: (state, payload) => state.comboDiscountTypes = payload,

  setComboAccessChainOptions: (state, payload) =>
    (state.comboAccessChainOptions = payload),
  setComboAccessChainsSelecteds: (state, payload) =>
    (state.comboAccessChainsSelecteds = payload),
  addNewComboAccessChainsSelecteds(state, valueChainSelected) {
    const NEW_CHAIN_SELECTED = state.comboAccessChainOptions.find(
      chainOption => chainOption.value === valueChainSelected
    )
    state.comboAccessChainsSelecteds.push(NEW_CHAIN_SELECTED)
  },
  deleteComboAccessChainsSelecteds(state, index) {
    state.comboAccessChainsSelecteds.splice(index, 1)
  },
  toggleComboAccessChainOptionsDisabled(state, valueChainSelected) {
    const INDEX_CHAIN_OPTION = state.comboAccessChainOptions.findIndex(
      chainOption => chainOption.value === valueChainSelected
    )
    state.comboAccessChainOptions[INDEX_CHAIN_OPTION].disabled =
      !state.comboAccessChainOptions[INDEX_CHAIN_OPTION].disabled
  },

  setComboCoverageStateOptions: (state, payload) =>
    (state.comboCoverageStateOptions = payload),
  setComboCoverageStatesSelecteds: (state, payload) =>
    (state.comboCoverageStatesSelecteds = payload),
  addNewComboCoverageStatesSelecteds(state, valueStateSelected) {
    const NEW_STATE_SELECTED = state.comboCoverageStateOptions.find(
      stateOption => stateOption.value === valueStateSelected
    )
    state.comboCoverageStatesSelecteds.push(NEW_STATE_SELECTED)
  },
  deleteComboCoverageStatesSelecteds(state, index) {
    state.comboCoverageStatesSelecteds.splice(index, 1)
  },
  updatePriceComboCoverageStatesSelecteds(state, { index, newPrice }) {
    state.comboCoverageStatesSelecteds[index].price = newPrice
  },
  toggleComboCoverageStateOptionsDisabled(state, valueStateSelected) {
    const INDEX_STATE_OPTION = state.comboCoverageStateOptions.findIndex(
      stateOption => stateOption.value === valueStateSelected
    )
    state.comboCoverageStateOptions[INDEX_STATE_OPTION].disabled =
      !state.comboCoverageStateOptions[INDEX_STATE_OPTION].disabled
  },

  setComboCoverageCityStateOptions: (state, payload) =>
    (state.comboCoverageCityStateOptions = payload),
  setComboCoverageCityStateSelected: (state, payload) =>
    (state.comboCoverageCityStateSelected = payload),
  setComboCoverageCityOptions: (state, payload) =>
    (state.comboCoverageCityOptions = payload),
  setComboCoverageCitySelecteds: (state, payload) =>
    (state.comboCoverageCitySelecteds = payload),
  addNewComboCoverageCitySelecteds(state, valueCitySelected) {
    const NEW_CITY_SELECTED = state.comboCoverageCityOptions.find(
      cityOption => cityOption.value === valueCitySelected
    )
    state.comboCoverageCitySelecteds.push(NEW_CITY_SELECTED)
  },
  deleteComboCoverageCitySelecteds(state, index) {
    state.comboCoverageCitySelecteds.splice(index, 1)
  },
  updatePriceComboCoverageCitySelecteds(state, { index, newPrice }) {
    state.comboCoverageCitySelecteds[index].price = newPrice
  },
  toggleComboCoverageCityOptionsDisabled(state, valueCitySelected) {
    const INDEX_CITY_OPTION = state.comboCoverageCityOptions.findIndex(
      cityOption => cityOption.value === valueCitySelected
    )

    if (INDEX_CITY_OPTION >= 0) {
      state.comboCoverageCityOptions[INDEX_CITY_OPTION].disabled =
        !state.comboCoverageCityOptions[INDEX_CITY_OPTION].disabled
    }
  },

  setComboCoverageDddOptions: (state, payload) =>
    (state.comboCoverageDddOptions = payload),
  setComboCoverageDddsSelecteds: (state, payload) =>
    (state.comboCoverageDddsSelecteds = payload),
  addNewComboCoverageDddsSelecteds(state, valueDddSelected) {
    const NEW_DDD_SELECTED = state.comboCoverageDddOptions.find(
      chainOption => chainOption.value === valueDddSelected
    )
    state.comboCoverageDddsSelecteds.push(NEW_DDD_SELECTED)
  },
  deleteComboCoverageDddsSelecteds(state, index) {
    state.comboCoverageDddsSelecteds.splice(index, 1)
  },
  toggleComboCoverageDddOptionsDisabled(state, valueDddSelected) {
    const INDEX_DDD_OPTION = state.comboCoverageDddOptions.findIndex(
      dddOption => dddOption.value === valueDddSelected
    )
    state.comboCoverageDddOptions[INDEX_DDD_OPTION].disabled =
      !state.comboCoverageDddOptions[INDEX_DDD_OPTION].disabled
  },
  updatePriceComboCoverageDddsSelecteds(state, { index, newPrice }) {
    state.comboCoverageDddsSelecteds[index].price = newPrice
  },

  setComboDiscountPaymentOptions: (state, payload) =>
    (state.comboDiscountPaymentOptions = payload),
  setComboDiscountPaymentSelecteds: (state, payload) =>
    (state.comboDiscountPaymentSelecteds = payload),
  addNewComboDiscountPaymentSelecteds(state, paymentSelected) {
    const NEW_PAYMENT_SELECTED = state.comboDiscountPaymentOptions.find(
      paymentOption => paymentOption.value === paymentSelected
    )
    state.comboDiscountPaymentSelecteds.push(NEW_PAYMENT_SELECTED)
  },
  deleteComboDiscountPaymentSelecteds(state, index) {
    state.comboDiscountPaymentSelecteds.splice(index, 1)
  },
  toggleComboDiscountPaymentOptionsDisabled(state, paymentSelected) {
    const INDEX_PAYMENT_OPTION = state.comboDiscountPaymentOptions.findIndex(
      paymentOption => paymentOption.value === paymentSelected
    )
    state.comboDiscountPaymentOptions[INDEX_PAYMENT_OPTION].disabled =
      !state.comboDiscountPaymentOptions[INDEX_PAYMENT_OPTION].disabled
  },
  updatePriceComboDiscountPaymentSelecteds(state, { index, newPrice }) {
    state.comboDiscountPaymentSelecteds[index].price = newPrice
  },

  setComboDiscountShippingOptions: (state, payload) =>
    (state.comboDiscountShippingOptions = payload),
  setComboDiscountShippingSelecteds: (state, payload) =>
    (state.comboDiscountShippingSelecteds = payload),
  addNewComboDiscountShippingSelecteds(state, shippingSelected) {
    const NEW_SHIPPING_SELECTED = state.comboDiscountShippingOptions.find(
      shippingOption => shippingOption.value === shippingSelected
    )
    state.comboDiscountShippingSelecteds.push(NEW_SHIPPING_SELECTED)
  },
  deleteComboDiscountShippingSelecteds(state, index) {
    state.comboDiscountShippingSelecteds.splice(index, 1)
  },
  toggleComboDiscountShippingOptionsDisabled(state, shippingSelected) {
    const INDEX_SHIPPING_OPTION = state.comboDiscountShippingOptions.findIndex(
      shippingOption => shippingOption.value === shippingSelected
    )
    state.comboDiscountShippingOptions[INDEX_SHIPPING_OPTION].disabled =
      !state.comboDiscountShippingOptions[INDEX_SHIPPING_OPTION].disabled
  },
  updatePriceComboDiscountShippingSelecteds(state, { index, newPrice }) {
    state.comboDiscountShippingSelecteds[index].price = newPrice
  },

  setComboAccessPosOptions: (state, payload) =>
    (state.comboAccessPosOptions = payload),
  setComboAccessPosSelecteds: (state, payload) =>
    (state.comboAccessPosSelecteds = payload),
  addNewComboAccessPosSelecteds(state, valuePosSelected) {
    const NEW_POS_SELECTED = state.comboAccessPosOptions.find(
      posOption => posOption.value === valuePosSelected
    )
    state.comboAccessPosSelecteds.push(NEW_POS_SELECTED)
  },
  deleteComboAccessPosSelecteds(state, index) {
    state.comboAccessPosSelecteds.splice(index, 1)
  },
  toggleComboAccessPosOptionsDisabled(state, valuePosSelected) {
    const INDEX_POS_OPTION = state.comboAccessPosOptions.findIndex(
      posOption => posOption.value === valuePosSelected
    )
    state.comboAccessPosOptions[INDEX_POS_OPTION].disabled =
      !state.comboAccessPosOptions[INDEX_POS_OPTION].disabled
  },
  resetCombo: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
